/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessTokenCreatedResponse,
  AccessTokenResponse,
  AuthControllerExchangeFromQueryParams,
  AuthControllerLoginParams,
  AuthControllerLogoutByQueryParams,
  CreateTokenRequest,
  ExchangePostRequest
} from './sAFcBackend.schemas.js';

import authControllerLoginMutator from '../response-type.js';
import authControllerExchangeFromQueryMutator from '../response-type.js';
import authControllerExchangeFromBodyMutator from '../response-type.js';
import authControllerLogoutByQueryMutator from '../response-type.js';
import authControllerLogoutByPostMutator from '../response-type.js';
import accessTokenControllerListTokensMutator from '../response-type.js';
import accessTokenControllerCreateTokenMutator from '../response-type.js';
import accessTokenControllerRemoveTokenMutator from '../response-type.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const authControllerLogin = (
    params?: AuthControllerLoginParams,
 options?: SecondParameter<typeof authControllerLoginMutator>,signal?: AbortSignal
) => {


      return authControllerLoginMutator<void>(
      {url: `/api/auth/login`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAuthControllerLoginQueryKey = (params?: AuthControllerLoginParams,) => {
    return [
    `/api/auth/login`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuthControllerLoginQueryOptions = <TData = Awaited<ReturnType<typeof authControllerLogin>>, TError = unknown>(params?: AuthControllerLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError, TData>>, request?: SecondParameter<typeof authControllerLoginMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerLoginQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerLogin>>> = ({ signal }) => authControllerLogin(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthControllerLoginQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerLogin>>>
export type AuthControllerLoginQueryError = unknown


export function useAuthControllerLogin<TData = Awaited<ReturnType<typeof authControllerLogin>>, TError = unknown>(
 params: undefined |  AuthControllerLoginParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerLogin>>,
          TError,
          Awaited<ReturnType<typeof authControllerLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof authControllerLoginMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerLogin<TData = Awaited<ReturnType<typeof authControllerLogin>>, TError = unknown>(
 params?: AuthControllerLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerLogin>>,
          TError,
          Awaited<ReturnType<typeof authControllerLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof authControllerLoginMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerLogin<TData = Awaited<ReturnType<typeof authControllerLogin>>, TError = unknown>(
 params?: AuthControllerLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError, TData>>, request?: SecondParameter<typeof authControllerLoginMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthControllerLogin<TData = Awaited<ReturnType<typeof authControllerLogin>>, TError = unknown>(
 params?: AuthControllerLoginParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError, TData>>, request?: SecondParameter<typeof authControllerLoginMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthControllerLoginQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const authControllerExchangeFromQuery = (
    params: AuthControllerExchangeFromQueryParams,
 options?: SecondParameter<typeof authControllerExchangeFromQueryMutator>,signal?: AbortSignal
) => {


      return authControllerExchangeFromQueryMutator<void>(
      {url: `/api/auth/exchange`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAuthControllerExchangeFromQueryQueryKey = (params?: AuthControllerExchangeFromQueryParams,) => {
    return [
    `/api/auth/exchange`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuthControllerExchangeFromQueryQueryOptions = <TData = Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError = unknown>(params: AuthControllerExchangeFromQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError, TData>>, request?: SecondParameter<typeof authControllerExchangeFromQueryMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerExchangeFromQueryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerExchangeFromQuery>>> = ({ signal }) => authControllerExchangeFromQuery(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthControllerExchangeFromQueryQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerExchangeFromQuery>>>
export type AuthControllerExchangeFromQueryQueryError = unknown


export function useAuthControllerExchangeFromQuery<TData = Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError = unknown>(
 params: AuthControllerExchangeFromQueryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerExchangeFromQuery>>,
          TError,
          Awaited<ReturnType<typeof authControllerExchangeFromQuery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof authControllerExchangeFromQueryMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerExchangeFromQuery<TData = Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError = unknown>(
 params: AuthControllerExchangeFromQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerExchangeFromQuery>>,
          TError,
          Awaited<ReturnType<typeof authControllerExchangeFromQuery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof authControllerExchangeFromQueryMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerExchangeFromQuery<TData = Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError = unknown>(
 params: AuthControllerExchangeFromQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError, TData>>, request?: SecondParameter<typeof authControllerExchangeFromQueryMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthControllerExchangeFromQuery<TData = Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError = unknown>(
 params: AuthControllerExchangeFromQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerExchangeFromQuery>>, TError, TData>>, request?: SecondParameter<typeof authControllerExchangeFromQueryMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthControllerExchangeFromQueryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Exchange Auth0 token, GGP auth token or GGP access token for auth token. Designed for programmatic usage
 */
export const authControllerExchangeFromBody = (
    exchangePostRequest: ExchangePostRequest,
 options?: SecondParameter<typeof authControllerExchangeFromBodyMutator>,signal?: AbortSignal
) => {


      return authControllerExchangeFromBodyMutator<string>(
      {url: `/api/auth/exchange`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exchangePostRequest, signal
    },
      options);
    }




export const getAuthControllerExchangeFromBodyMutationKey = () => ['authControllerExchangeFromBody'] as const;

export const getAuthControllerExchangeFromBodyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerExchangeFromBody>>, TError,AuthControllerExchangeFromBodyMutationVariables, TContext>, request?: SecondParameter<typeof authControllerExchangeFromBodyMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerExchangeFromBody>>, TError,AuthControllerExchangeFromBodyMutationVariables, TContext> => {

const mutationKey = getAuthControllerExchangeFromBodyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerExchangeFromBody>>, AuthControllerExchangeFromBodyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authControllerExchangeFromBody(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerExchangeFromBodyMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerExchangeFromBody>>>
    export type AuthControllerExchangeFromBodyMutationBody = ExchangePostRequest
    export type AuthControllerExchangeFromBodyMutationError = unknown
    export type AuthControllerExchangeFromBodyMutationVariables = {data: ExchangePostRequest}

    export const useAuthControllerExchangeFromBody = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerExchangeFromBody>>, TError,AuthControllerExchangeFromBodyMutationVariables, TContext>, request?: SecondParameter<typeof authControllerExchangeFromBodyMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerExchangeFromBody>>,
        TError,
        AuthControllerExchangeFromBodyMutationVariables,
        TContext
      > => {
      return useMutation(getAuthControllerExchangeFromBodyMutationOptions(options), queryClient);
    }
    export const authControllerLogoutByQuery = (
    params?: AuthControllerLogoutByQueryParams,
 options?: SecondParameter<typeof authControllerLogoutByQueryMutator>,signal?: AbortSignal
) => {


      return authControllerLogoutByQueryMutator<void>(
      {url: `/api/auth/logout`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAuthControllerLogoutByQueryQueryKey = (params?: AuthControllerLogoutByQueryParams,) => {
    return [
    `/api/auth/logout`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuthControllerLogoutByQueryQueryOptions = <TData = Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError = unknown>(params?: AuthControllerLogoutByQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError, TData>>, request?: SecondParameter<typeof authControllerLogoutByQueryMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthControllerLogoutByQueryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authControllerLogoutByQuery>>> = ({ signal }) => authControllerLogoutByQuery(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthControllerLogoutByQueryQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerLogoutByQuery>>>
export type AuthControllerLogoutByQueryQueryError = unknown


export function useAuthControllerLogoutByQuery<TData = Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError = unknown>(
 params: undefined |  AuthControllerLogoutByQueryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerLogoutByQuery>>,
          TError,
          Awaited<ReturnType<typeof authControllerLogoutByQuery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof authControllerLogoutByQueryMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerLogoutByQuery<TData = Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError = unknown>(
 params?: AuthControllerLogoutByQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authControllerLogoutByQuery>>,
          TError,
          Awaited<ReturnType<typeof authControllerLogoutByQuery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof authControllerLogoutByQueryMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthControllerLogoutByQuery<TData = Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError = unknown>(
 params?: AuthControllerLogoutByQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError, TData>>, request?: SecondParameter<typeof authControllerLogoutByQueryMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuthControllerLogoutByQuery<TData = Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError = unknown>(
 params?: AuthControllerLogoutByQueryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authControllerLogoutByQuery>>, TError, TData>>, request?: SecondParameter<typeof authControllerLogoutByQueryMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthControllerLogoutByQueryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Invalidate auth token
 */
export const authControllerLogoutByPost = (

 options?: SecondParameter<typeof authControllerLogoutByPostMutator>,signal?: AbortSignal
) => {


      return authControllerLogoutByPostMutator<void>(
      {url: `/api/auth/logout`, method: 'POST', signal
    },
      options);
    }




export const getAuthControllerLogoutByPostMutationKey = () => ['authControllerLogoutByPost'] as const;

export const getAuthControllerLogoutByPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogoutByPost>>, TError,void, TContext>, request?: SecondParameter<typeof authControllerLogoutByPostMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerLogoutByPost>>, TError,void, TContext> => {

const mutationKey = getAuthControllerLogoutByPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLogoutByPost>>, void> = () => {


          return  authControllerLogoutByPost(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerLogoutByPostMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLogoutByPost>>>

    export type AuthControllerLogoutByPostMutationError = unknown


    export const useAuthControllerLogoutByPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogoutByPost>>, TError,void, TContext>, request?: SecondParameter<typeof authControllerLogoutByPostMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerLogoutByPost>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAuthControllerLogoutByPostMutationOptions(options), queryClient);
    }
    export const accessTokenControllerListTokens = (

 options?: SecondParameter<typeof accessTokenControllerListTokensMutator>,signal?: AbortSignal
) => {


      return accessTokenControllerListTokensMutator<AccessTokenResponse[]>(
      {url: `/api/auth/access-token`, method: 'GET', signal
    },
      options);
    }




export const getAccessTokenControllerListTokensQueryKey = () => {
    return [
    `/api/auth/access-token`
    ] as const;
    }


export const getAccessTokenControllerListTokensQueryOptions = <TData = Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError, TData>>, request?: SecondParameter<typeof accessTokenControllerListTokensMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccessTokenControllerListTokensQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof accessTokenControllerListTokens>>> = ({ signal }) => accessTokenControllerListTokens(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccessTokenControllerListTokensQueryResult = NonNullable<Awaited<ReturnType<typeof accessTokenControllerListTokens>>>
export type AccessTokenControllerListTokensQueryError = unknown


export function useAccessTokenControllerListTokens<TData = Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessTokenControllerListTokens>>,
          TError,
          Awaited<ReturnType<typeof accessTokenControllerListTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accessTokenControllerListTokensMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccessTokenControllerListTokens<TData = Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessTokenControllerListTokens>>,
          TError,
          Awaited<ReturnType<typeof accessTokenControllerListTokens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof accessTokenControllerListTokensMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccessTokenControllerListTokens<TData = Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError, TData>>, request?: SecondParameter<typeof accessTokenControllerListTokensMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccessTokenControllerListTokens<TData = Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accessTokenControllerListTokens>>, TError, TData>>, request?: SecondParameter<typeof accessTokenControllerListTokensMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccessTokenControllerListTokensQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Create new access token
 */
export const accessTokenControllerCreateToken = (
    createTokenRequest: CreateTokenRequest,
 options?: SecondParameter<typeof accessTokenControllerCreateTokenMutator>,signal?: AbortSignal
) => {


      return accessTokenControllerCreateTokenMutator<AccessTokenCreatedResponse>(
      {url: `/api/auth/access-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTokenRequest, signal
    },
      options);
    }




export const getAccessTokenControllerCreateTokenMutationKey = () => ['accessTokenControllerCreateToken'] as const;

export const getAccessTokenControllerCreateTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerCreateToken>>, TError,AccessTokenControllerCreateTokenMutationVariables, TContext>, request?: SecondParameter<typeof accessTokenControllerCreateTokenMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerCreateToken>>, TError,AccessTokenControllerCreateTokenMutationVariables, TContext> => {

const mutationKey = getAccessTokenControllerCreateTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accessTokenControllerCreateToken>>, AccessTokenControllerCreateTokenMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  accessTokenControllerCreateToken(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccessTokenControllerCreateTokenMutationResult = NonNullable<Awaited<ReturnType<typeof accessTokenControllerCreateToken>>>
    export type AccessTokenControllerCreateTokenMutationBody = CreateTokenRequest
    export type AccessTokenControllerCreateTokenMutationError = unknown
    export type AccessTokenControllerCreateTokenMutationVariables = {data: CreateTokenRequest}

    export const useAccessTokenControllerCreateToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerCreateToken>>, TError,AccessTokenControllerCreateTokenMutationVariables, TContext>, request?: SecondParameter<typeof accessTokenControllerCreateTokenMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accessTokenControllerCreateToken>>,
        TError,
        AccessTokenControllerCreateTokenMutationVariables,
        TContext
      > => {
      return useMutation(getAccessTokenControllerCreateTokenMutationOptions(options), queryClient);
    }
    /**
 * Delete access token
 */
export const accessTokenControllerRemoveToken = (
    id: string,
 options?: SecondParameter<typeof accessTokenControllerRemoveTokenMutator>,signal?: AbortSignal
) => {


      return accessTokenControllerRemoveTokenMutator<void>(
      {url: `/api/auth/access-token/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getAccessTokenControllerRemoveTokenMutationKey = () => ['accessTokenControllerRemoveToken'] as const;

export const getAccessTokenControllerRemoveTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerRemoveToken>>, TError,AccessTokenControllerRemoveTokenMutationVariables, TContext>, request?: SecondParameter<typeof accessTokenControllerRemoveTokenMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerRemoveToken>>, TError,AccessTokenControllerRemoveTokenMutationVariables, TContext> => {

const mutationKey = getAccessTokenControllerRemoveTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accessTokenControllerRemoveToken>>, AccessTokenControllerRemoveTokenMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  accessTokenControllerRemoveToken(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AccessTokenControllerRemoveTokenMutationResult = NonNullable<Awaited<ReturnType<typeof accessTokenControllerRemoveToken>>>

    export type AccessTokenControllerRemoveTokenMutationError = unknown
    export type AccessTokenControllerRemoveTokenMutationVariables = {id: string}

    export const useAccessTokenControllerRemoveToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accessTokenControllerRemoveToken>>, TError,AccessTokenControllerRemoveTokenMutationVariables, TContext>, request?: SecondParameter<typeof accessTokenControllerRemoveTokenMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accessTokenControllerRemoveToken>>,
        TError,
        AccessTokenControllerRemoveTokenMutationVariables,
        TContext
      > => {
      return useMutation(getAccessTokenControllerRemoveTokenMutationOptions(options), queryClient);
    }
